// Map common language names to ISO 639-1 codes (matches backend _LANG_TO_ISO)
export const LANG_TO_ISO = {
  English: "en", Spanish: "es", Mandarin: "zh", Cantonese: "zh",
  Arabic: "ar", French: "fr", German: "de", Italian: "it",
  Portuguese: "pt", Russian: "ru", Polish: "pl", Ukrainian: "uk",
  Romanian: "ro", Greek: "el", Turkish: "tr", Hebrew: "he",
  "Persian (Farsi)": "fa", Urdu: "ur", Hindi: "hi", Bengali: "bn",
  Vietnamese: "vi", Thai: "th", Indonesian: "id", Malay: "ms",
  Tagalog: "tl", Japanese: "ja", Korean: "ko", Dutch: "nl",
  Swedish: "sv", Norwegian: "no", Danish: "da", Finnish: "fi",
  Czech: "cs", Hungarian: "hu", Bulgarian: "bg", Serbian: "sr",
  Croatian: "hr", "Haitian Creole": "ht",
};

export const isoForLang = (name) => LANG_TO_ISO[name] || "";
